var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 12,
    fill: "none",
    viewBox: "0 0 10 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F2FAFF",
    d: "M6.74996 1.5H8.99996C9.44996 1.5 9.74996 1.8 9.74996 2.25V3H-3.8147e-05V2.25C-3.8147e-05 1.8 0.374962 1.5 0.749962 1.5H2.99996C3.14996 0.675004 3.97496 3.8147e-06 4.87496 3.8147e-06C5.77496 3.8147e-06 6.59996 0.675004 6.74996 1.5ZM3.74996 1.5H5.99996C5.84996 1.05 5.32496 0.750004 4.87496 0.750004C4.42496 0.750004 3.89996 1.05 3.74996 1.5ZM0.749962 3.75H8.99996L8.32496 11.325C8.32496 11.7 7.94996 12 7.57496 12H2.17496C1.79996 12 1.49996 11.7 1.42496 11.325L0.749962 3.75Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.1790bdbaa0334ff14348cf9d8dfa6ae2.svg";
export { ForwardRef as ReactComponent };